'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/uri.js
// module id = 679
// module chunks = 0